// Models
import { ReelViewModel } from '../models/reel-view.model';

export namespace ReelActions {
	export class GetAll {
		static readonly type = '[Reel] Get Reels';
		constructor(public data: { showSpinner?: boolean; showToast?: boolean } = { showSpinner: false, showToast: false }) {}
	}

	export class SetAll {
		static readonly type = '[Reel] Set Reels';
		constructor(public reels: ReelViewModel[]) {}
	}

	export class Create {
		static readonly type = '[Reel] Create Reel';
		constructor(public data: { reel: ReelViewModel; showSpinner?: boolean; showToast?: boolean } = { reel: null, showSpinner: false, showToast: false }) {}
	}

	export class CreateSuccess {
		static readonly type = '[Reel] Create Reel Success';
		constructor(public reel: ReelViewModel) {}
	}

	export class CreateError {
		static readonly type = '[Reel] Create Reel Error';
	}

	export class Update {
		static readonly type = '[Reel] Update Reel';
		constructor(public data: { reel: ReelViewModel; showSpinner?: boolean; showToast?: boolean } = { reel: null, showSpinner: false, showToast: false }) {}
	}

	export class UpdateSuccess {
		static readonly type = '[Reel] Update Reel Success';
		constructor(public reel: ReelViewModel) {}
	}

	export class UpdateError {
		static readonly type = '[Reel] Update Reel Error';
	}

	export class Delete {
		static readonly type = '[Reel] Delete Reel';
		constructor(public data: { id: number; showSpinner?: boolean; showToast?: boolean; showConfirm: boolean } = { id: null, showSpinner: false, showToast: false, showConfirm: false }) {}
	}
}
